/* ==========================================================================
   NARAMAXX — FAVORİLERİM / WISHLIST  —  assets/wishlist.js
   --------------------------------------------------------------------------
   • Depolama: localStorage. Müşteri giriş yapmışsa anahtar müşteri ID'sine
     göre ayrılır (nm_wishlist_v1_c123456789) — aynı cihazı kullanan iki
     müşterinin listeleri karışmaz. Misafirken eklenenler, giriş yapıldığında
     müşterinin listesine bir kez birleştirilir.
   • Opsiyonel sunucu senkronu: NMWishlistConfig.syncEndpoint verilirse
     (App Proxy) GET ile okur, POST ile yazar. Yoksa tamamen client-side.
   • Ürün kartlarına kalp butonu JS ile enjekte edilir (tema kart snippet'ini
     değiştirmeye gerek yok) + MutationObserver ile AJAX/sonsuz scroll destekli.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.NMWishlistConfig || (window.NMWishlistConfig = {});
  var KEY_BASE = 'nm_wishlist_v1';
  var LABEL_ADD = 'Favorilere ekle';
  var LABEL_REMOVE = 'Favorilerden çıkar';

  /* ---------------------------------------------------------------- Store */
  function storageKey() {
    var c = CFG.customerId ? String(CFG.customerId) : '';
    return c ? KEY_BASE + '_c' + c : KEY_BASE;
  }

  function readKey(k) {
    try {
      var raw = localStorage.getItem(k);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return [];
      return arr.filter(function (i) { return i && typeof i.h === 'string' && i.h; });
    } catch (e) { return []; }
  }

  function writeKey(k, items) {
    try { localStorage.setItem(k, JSON.stringify(items)); } catch (e) {}
  }

  var items = [];

  function load() {
    items = readKey(storageKey());
    // Misafirken eklenenleri müşteri listesine bir defa taşı
    if (CFG.customerId) {
      var guest = readKey(KEY_BASE);
      if (guest.length) {
        guest.forEach(function (g) {
          if (!find(g.h)) items.push({ h: g.h, t: g.t || Date.now() });
        });
        try { localStorage.removeItem(KEY_BASE); } catch (e) {}
        persist();
      }
    }
  }

  function find(handle) {
    for (var i = 0; i < items.length; i++) if (items[i].h === handle) return items[i];
    return null;
  }

  function persist(skipSync) {
    writeKey(storageKey(), items);
    if (!skipSync) pushSync();
    document.dispatchEvent(new CustomEvent('nm:wishlist:change', {
      detail: { handles: handles(), count: items.length }
    }));
    refreshUI();
  }

  function handles() {
    return items.slice().sort(function (a, b) { return (b.t || 0) - (a.t || 0); })
                .map(function (i) { return i.h; });
  }

  var API = {
    all: handles,
    count: function () { return items.length; },
    has: function (h) { return !!find(h); },
    add: function (h) { if (h && !find(h)) { items.push({ h: h, t: Date.now() }); persist(); } },
    remove: function (h) {
      items = items.filter(function (i) { return i.h !== h; });
      persist();
    },
    toggle: function (h) { API.has(h) ? API.remove(h) : API.add(h); return API.has(h); },
    clear: function () { items = []; persist(); }
  };
  window.NMWishlist = API;

  /* --------------------------------------------------- Opsiyonel sunucu sync
     Kontrat (App Proxy, ör. /apps/favoriler):
       GET  → { ok:true, handles:["urun-1","urun-2"] }
       POST → body: { handles:[...] }  → { ok:true }
     Müşteri metafield'ında saklamak istersen bu uçları bir sunucuya bağla.
     Endpoint yoksa bu blok hiç çalışmaz. */
  function pullSync() {
    if (!CFG.syncEndpoint || !CFG.customerId) return;
    fetch(CFG.syncEndpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.handles)) return;
        var changed = false;
        data.handles.forEach(function (h) {
          if (typeof h === 'string' && h && !find(h)) { items.push({ h: h, t: Date.now() }); changed = true; }
        });
        if (changed) persist(true);
        else refreshUI();
      })
      .catch(function () {});
  }

  var syncTimer = null;
  function pushSync() {
    if (!CFG.syncEndpoint || !CFG.customerId) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch(CFG.syncEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ handles: handles() })
      }).catch(function () {});
    }, 400);
  }

  /* ------------------------------------------------------------ Buton HTML */
  var HEART = '<svg class="nm-wish__icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.3 3.9 12.5a5 5 0 0 1 7.1-7l1 1 1-1a5 5 0 1 1 7.1 7L12 20.3Z" ' +
    'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  function makeButton(handle, extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nm-wish' + (extraClass ? ' ' + extraClass : '');
    b.setAttribute('data-nm-wish', handle);
    b.setAttribute('aria-pressed', 'false');
    b.setAttribute('aria-label', LABEL_ADD);
    b.setAttribute('title', LABEL_ADD);
    b.innerHTML = HEART;
    return b;
  }

  function syncButton(btn) {
    var h = btn.getAttribute('data-nm-wish');
    var on = API.has(h);
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? LABEL_REMOVE : LABEL_ADD);
    btn.setAttribute('title', on ? LABEL_REMOVE : LABEL_ADD);
  }

  function refreshUI() {
    document.querySelectorAll('[data-nm-wish]').forEach(syncButton);
    var n = API.count();
    document.querySelectorAll('[data-nm-wishlist-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-nm-wishlist-count-always]').forEach(function (el) {
      el.textContent = String(n);
    });
  }

  /* Tek delege listener — sonradan gelen butonlar için de çalışır */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nm-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.getAttribute('data-nm-wish');
    if (!h) return;
    API.toggle(h);
    btn.classList.add('nm-wish--pulse');
    setTimeout(function () { btn.classList.remove('nm-wish--pulse'); }, 320);
    if (btn.hasAttribute('data-nm-wish-page-item')) {
      var card = btn.closest('[data-nm-wl-card]');
      if (card && !API.has(h)) { card.remove(); renderPageEmptyCheck(); }
    }
  }, true);

  /* --------------------------------------------- Ürün kartlarına enjeksiyon */
  var CARD_SELECTORS = CFG.cardSelectors ||
    'product-block, .product-block, .product-grid-item, .product-card, [data-product-block]';
  var MEDIA_SELECTORS = CFG.cardMediaSelectors ||
    '.image-cont, .product-block__image, .product-block__media, .card__media, .media--product';

  function handleFromCard(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    return handleFromUrl(a.getAttribute('href') || '');
  }

  function handleFromUrl(href) {
    var m = String(href).split('?')[0].match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  function injectCards(scope) {
    if (CFG.disableCardInject) return;
    (scope || document).querySelectorAll(CARD_SELECTORS).forEach(function (card) {
      if (card.__nmWish) return;
      if (card.closest('[data-nm-wishlist-page]')) return; // sayfa kartları kendi butonunu basıyor
      var h = handleFromCard(card);
      if (!h) return;
      card.__nmWish = true;
      var host = card.querySelector(MEDIA_SELECTORS) || card;
      host.classList.add('nm-wish-host');
      var btn = makeButton(h, 'nm-wish--card');
      host.appendChild(btn);
      syncButton(btn);
    });
  }

  /* NaraMaxx ürün kartında renk swatch'ına tıklanınca kart başka bir ürüne
     (aynı modelin diğer renk varyantı) işaret ediyor. Kalbin handle'ını da
     güncelle — tema kendi tıklama handler'ında href'leri değiştirdikten sonra. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.pb-swatch a');
    if (!sw) return;
    var card = sw.closest(CARD_SELECTORS);
    if (!card) return;
    setTimeout(function () {
      var btn = card.querySelector('[data-nm-wish]');
      if (!btn) return;
      var h = handleFromUrl(sw.getAttribute('href') || '') || handleFromCard(card);
      if (h) { btn.setAttribute('data-nm-wish', h); syncButton(btn); }
    }, 0);
  });

  /* ------------------------------------------------- Favorilerim sayfası */
  var pageEl = null;

  function money(cents) {
    var fmt = CFG.moneyFormat || '{{amount_with_comma_separator}} TL';
    var v = Number(cents || 0) / 100;
    function withDelims(num, thousand, decimal, places) {
      var fixed = num.toFixed(places);
      var parts = fixed.split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand);
      return places ? int + decimal + parts[1] : int;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withDelims(v, ',', '.', 2);
        case 'amount_no_decimals': return withDelims(v, ',', '.', 0);
        case 'amount_with_comma_separator': return withDelims(v, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return withDelims(v, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return withDelims(v, "'", '.', 2);
        default: return withDelims(v, '.', ',', 2);
      }
    });
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + w + 'x$1$2');
  }

  function fetchProduct(handle) {
    var root = (CFG.routesRoot || '/').replace(/\/$/, '');
    return fetch(root + '/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function cardHTML(p) {
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    var soldOut = !p.available;
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    return '' +
      '<li class="nm-wl__card" data-nm-wl-card data-handle="' + escAttr(p.handle) + '">' +
        '<div class="nm-wl__media nm-wish-host">' +
          '<a href="' + escAttr(p.url || ('/products/' + p.handle)) + '" class="nm-wl__img-link">' +
            (img ? '<img src="' + escAttr(imgUrl(img, 600)) + '" alt="' + escAttr(p.title) + '" loading="lazy" width="600" height="800">' : '') +
          '</a>' +
          '<button type="button" class="nm-wish nm-wish--card is-active" data-nm-wish="' + escAttr(p.handle) + '" ' +
                  'data-nm-wish-page-item aria-pressed="true" aria-label="' + LABEL_REMOVE + '" title="' + LABEL_REMOVE + '">' + HEART + '</button>' +
          (soldOut ? '<span class="nm-wl__badge">Tükendi</span>' : '') +
        '</div>' +
        '<div class="nm-wl__info">' +
          '<a class="nm-wl__title" href="' + escAttr(p.url || ('/products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
          '<div class="nm-wl__price">' +
            (onSale ? '<s class="nm-wl__was">' + money(p.compare_at_price) + '</s> ' : '') +
            '<span class="nm-wl__now' + (onSale ? ' is-sale' : '') + '">' + money(p.price) + '</span>' +
          '</div>' +
          (CFG.showAddToCart && p.available && p.variants && p.variants.length === 1
            ? '<button type="button" class="nm-wl__atc" data-nm-wl-add="' + p.variants[0].id + '">Sepete Ekle</button>'
            : '<a class="nm-wl__atc nm-wl__atc--link" href="' + escAttr(p.url || ('/products/' + p.handle)) + '">İncele</a>') +
        '</div>' +
      '</li>';
  }

  function renderPage() {
    pageEl = document.querySelector('[data-nm-wishlist-page]');
    if (!pageEl) return;
    var grid = pageEl.querySelector('[data-nm-wl-grid]');
    var empty = pageEl.querySelector('[data-nm-wl-empty]');
    var loading = pageEl.querySelector('[data-nm-wl-loading]');
    var list = handles();

    if (!list.length) {
      if (loading) loading.hidden = true;
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;

    Promise.all(list.map(fetchProduct)).then(function (products) {
      var ok = products.filter(Boolean);
      // Silinmiş/yayından kalkmış ürünleri listeden temizle
      var alive = {};
      ok.forEach(function (p) { alive[p.handle] = true; });
      var before = items.length;
      items = items.filter(function (i) { return alive[i.h]; });
      if (items.length !== before) writeKey(storageKey(), items);

      if (loading) loading.hidden = true;
      if (!ok.length) { if (empty) empty.hidden = false; return; }
      if (grid) grid.innerHTML = ok.map(cardHTML).join('');
      refreshUI();
    });
  }

  function renderPageEmptyCheck() {
    if (!pageEl) return;
    var grid = pageEl.querySelector('[data-nm-wl-grid]');
    var empty = pageEl.querySelector('[data-nm-wl-empty]');
    if (grid && !grid.children.length && empty) empty.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nm-wl-add]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-nm-wl-add');
    var txt = b.textContent;
    b.disabled = true; b.textContent = 'Ekleniyor…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      b.textContent = 'Sepete eklendi';
      // Tema sepet drawer'ını tetiklemeye çalış (Symmetry & yaygın olaylar)
      ['cart:refresh', 'cart:build', 'cart:updated', 'ajaxProduct:added'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
    }).catch(function () {
      b.textContent = 'Hata, tekrar deneyin';
    }).then(function () {
      setTimeout(function () { b.disabled = false; b.textContent = txt; }, 1800);
    });
  });

  /* ------------------------------------------------------------- Yardımcı */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escAttr(s) { return esc(s); }

  /* ------------------------------------------------------------------ Init */
  function init() {
    load();
    injectCards(document);
    refreshUI();
    renderPage();
    pullSync();
    // "Sevilen ürün!" rozeti gibi dinleyiciler ilk durumu alsın
    document.dispatchEvent(new CustomEvent('nm:wishlist:change', {
      detail: { handles: handles(), count: items.length }
    }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  document.addEventListener('shopify:section:load', function (e) {
    injectCards(e.target || document);
    refreshUI();
    renderPage();
  });

  document.addEventListener('nm:wishlist:change', function () {
    if (pageEl && !document.querySelector('[data-nm-wl-grid]').children.length) renderPage();
  });

  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) {
          clearTimeout(pending);
          pending = setTimeout(function () { injectCards(document); refreshUI(); }, 120);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();